module.exports = __webpack_public_path__ + "img/ic_video.b057ab2a.svg";